import { useTranslation } from "react-i18next";
import { IconBell01 } from "@pentabd/icons";
import { Header } from "@pentabd/ui";

export const NotificationsHeader = () => {
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      icon: <IconBell01 fill="dark" size="20" />,
    },
    {
      label: t("NOTIFICATIONS.BREADCRUMBS.FIRST_STEP"),
    },
  ];

  return <Header breadcrumbs={breadcrumbs} className="px-9 py-8" />;
};
